import { render, staticRenderFns } from "./SectionPrehomeEditBannerComponent.vue?vue&type=template&id=255d0eb0"
import script from "./SectionPrehomeEditBannerComponent.vue?vue&type=script&lang=js"
export * from "./SectionPrehomeEditBannerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports